import { render, staticRenderFns } from "./album.vue?vue&type=template&id=15977e97&scoped=true"
import script from "./album.vue?vue&type=script&lang=js"
export * from "./album.vue?vue&type=script&lang=js"
import style0 from "./album.vue?vue&type=style&index=0&id=15977e97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15977e97",
  null
  
)

export default component.exports